import { useState } from 'react'
import { BiTrash, BiEdit, BiCheck, BiSolidBriefcase, BiPhone, BiPlus, BiSitemap, BiShow, BiLink } from 'react-icons/bi';
import { GrDocumentPdf } from "react-icons/gr";
import { RiFileExcel2Line } from "react-icons/ri";
import { FaChartPie } from "react-icons/fa";

const Action = ({ type, action }) => {
    const [actions, setActions] = useState({
        pdfExcel: <GrDocumentPdf onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={'Clique para detalhes'} style={{ fontSize: '17px', color: 'green' }} />,
        excel: <RiFileExcel2Line onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        pdf: <GrDocumentPdf onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={'Clique para resumo'} style={{ fontSize: '17px' }} />,
        visualizar: <BiShow onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        editar: <BiEdit className='actions-buttons hover:scale-110 transition-transform duration-200 hover:text-vox-blue-600' onClick={action} title={`Clique para ${type}`} />,
        deletar: <BiTrash onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200 hover:text-red-600' color='red' title={`Clique para ${type}`} />,
        vincular: <BiSolidBriefcase onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        linhas: <BiPhone onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        adicionar: <BiPlus onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        equipamentos: <FaChartPie onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        itens: <BiSitemap onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />,
        vincularPatrimonios: <BiLink onClick={action} className='actions-buttons hover:scale-110 transition-transform duration-200' title={`Clique para ${type}`} />
    })

    return (
        <>
            <div className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200">
                {actions[type]}
            </div>
        </>
    )
}

export default Action
